import { WidgetType } from 'domain/entity/widget';
import TimeseriesData, { TimeserieMetadata, TimeValue } from 'domain/entity/widgets/TimeseriesData';

export type JsonTimeseries = {
    type: WidgetType;
    timeseries: JsonTimeserie[];
};

type JsonTimeserie = { id: string; timevalues: TimeValue[]; ['meta_data']: TimeserieMetadata };

export const asTimeseries = (json: JsonTimeseries): TimeseriesData =>
    new TimeseriesData(
        json.timeseries.map((timeserie) => ({
            id: timeserie.id,
            timeValues: timeserie.timevalues.map((timevalue) => ({ t: new Date(Date.parse(`${timevalue.t}+00:00`)), v: timevalue.v })),
            metadata: {
                ...timeserie.meta_data,
                from: new Date(Date.parse(`${timeserie.meta_data.from}+00:00`)),
                to: new Date(Date.parse(`${timeserie.meta_data.to}+00:00`)),
            },
        }))
    );
